/**
 * Domain of the "alreadyAuth" cookie read by the showcase site: the parent
 * domain of the current host, so client.studentpop.fr writes it for
 * .studentpop.fr and client.talentwork.fr for .talentwork.fr (SP-14858).
 * Hosts without a parent domain (localhost, IPs) get a host-only cookie.
 */
export default function siteCookieDomain(hostname = window.location.hostname) {
  const labels = hostname.split('.');
  if (labels.length < 2 || /^\d+$/.test(labels[labels.length - 1])) return '';

  return `domain=.${labels.slice(-2).join('.')};`;
}
